module.exports = __webpack_public_path__ + "media/images/japan/underline-8ce96c2bc9f52c7175a4339097dc11c7.svg";